/** @type {import('../help-index.js').HelpSidebarItem} */
export const AGR_CUL_RIEGO_ITEM = {
  id: 'agro_cultivos_riego',
  screenId: 'agr-cul-riego',
  label: 'Riego',
  description: 'Plan de riego de una siembra ya cargada (Kc, ETc, láminas y agotamiento).',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Sobre una siembra existente, el sistema arma un plan de riego usando clima, cultivo (Kc) y parámetros de la siembra (profundidad radicular, eficiencia).',
      },
      {
        title: 'Paso 1 — Elegir la siembra',
        fields: [
          {
            label: 'Cultivo / siembra',
            description:
              'Selector de siembra (campaña, cultivo, campo/zona). Al elegirla se carga el plan automáticamente.',
          },
        ],
      },
      {
        title: 'Qué vas a ver',
        bullets: [
          'Indicadores resumidos del plan (demanda, lluvia, riego sugerido, etc.).',
          'Gráficos de Kc, ETc y lluvia efectiva.',
          'Calendario o barras de lámina de riego.',
          'Curva de agotamiento de agua en el suelo.',
        ],
        paragraphs: [
          'Si falta clima o configuración del cultivo, aparece un mensaje de error en pantalla. Completá Climatología y Configuración del cultivo, y volvé a elegir la siembra.',
        ],
      },
      {
        title: 'Relación con Eventos',
        paragraphs: [
          'Los riegos reales se cargan en Agro → Eventos → Riego. Esta pantalla es de planificación/consulta; no reemplaza el registro del riego aplicado.',
        ],
      },
    ],
  },
}
